import { render, staticRenderFns } from "./DayOfWeekBarChart.vue?vue&type=template&id=a5e45ade&scoped=true"
import script from "./DayOfWeekBarChart.vue?vue&type=script&lang=js"
export * from "./DayOfWeekBarChart.vue?vue&type=script&lang=js"
import style0 from "./DayOfWeekBarChart.vue?vue&type=style&index=0&id=a5e45ade&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e45ade",
  null
  
)

export default component.exports